/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupePlusIcon16Solid = forwardRef('SearchLoupePlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.875 5a.875.875 0 1 0-1.75 0v1.125H6a.875.875 0 1 0 0 1.75h1.125V9a.875.875 0 1 0 1.75 0V7.875H10a.875.875 0 0 0 0-1.75H8.875V5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.3 7a6.7 6.7 0 1 1 12.092 3.978l2.317 2.317a1 1 0 1 1-1.414 1.414l-2.317-2.317A6.7 6.7 0 0 1 1.3 7ZM8 2.3a4.7 4.7 0 1 0 0 9.4 4.7 4.7 0 0 0 0-9.4Z" })));
});
